<template lang="pug">
  b-container.h-100.p-0#container(fluid)
    b-card.my-0.mx-0.h-100.p-3.no-shadow(no-body, :style="composerStyle")
      b-row.flex-column.h-100.flex-nowrap
        b-col.bb-1(cols="auto")
          b-row.mb-3.align-items-center.justify-content-between
            b-col.d-flex.align-items-center.my-1(cols="auto")
              Avatar.mr-3(size="xs", :src="userData.profile_pic", :platform="conversation.platform", @click="openUserInfo")
              .d-flex.flex-column.justify-content-center
                .d-flex.align-items-center
                  b-link.d-none.d-md-block.mr-3.text-reset(@click="openUserInfo") {{ userName }}
                  b-spinner(small, variant="primary", v-if="$store.getters['loader/isAxiosLoading']")
            b-col(cols="auto")
              .d-flex.align-items-center.my-1(v-if="Object.keys(conversation).length")
                inbox-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Cambiar bandeja'", @click="side_modal_box = true")
                users-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Asignar admins'", @click="side_modal_admins = true")
                tag-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Etiquetar'", @click="side_modal_labels = true")
                search-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Buscar mensajes'", @click="search_modal = true", :class="{'text-primary' : selectedMessage}")
                span.text-help.mx-2 |
                alert-circle-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Información del usuario'", @click="openUserInfo")
                shopping-cart-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Orden del usuario'", @click="side_modal_cart = true", v-if="isEcommerce")
                file-text-icon.icon-md.hover-primary.pointer.mx-2(v-b-tooltip.hover="'Historial de ordenes'", @click="side_modal_orders = true", v-if="isEcommerce")
                b-badge.pointer.mx-2(variant="soft-danger", @click="openUserInfo", v-if="!conversation.bot_enabled") Bot desactivado
                b-button(v-if="['voip', 'whatsapp_official'].includes(conversation.platform)", pill, size="sm", variant="soft-primary", @click="isCallPanelOpen = !isCallPanelOpen")
                  phone-call-icon.icon-sm
              .text-center
                b-link(v-if="selectedMessage", @click="clearSearch") Cerrar busqueda
        b-col.overflow-y.scrollable-area.pt-3#messages-container(
          @v-chat-scroll-top-reached="loadMoreMessages",
          v-chat-scroll="{ notSmoothOnInit: false, always: true, smooth: true }"
        )
          chat-templates(
            :admins="admins",
            :tags="tags",
            :groups="groups",
            :viewerOptions="viewerOptions",
            :parsed_conversation_messages="parsed_conversation_messages",
            @messageTook="handleMessageTook",
            @goToExactMessage="goToExactMessage"
          )
        b-col.bt-1.d-flex.scrollable-area.overflow-x(cols="auto", style="white-space:nowrap;", v-if="messageToAnswer && (messageToAnswer.wamID || messageToAnswer.externalId)")
          .attachment-holder.d-inline-flex.bg-light
            span {{ messageToAnswer.text }}
            b-link.text-sm.text-danger.opacity-70.ml-2(@click="messageToAnswer = null", href="#")
              x-icon
        b-col.bt-1.d-flex.scrollable-area.overflow-x(cols="auto", style="white-space:nowrap;", v-if="files.length")
          .attachment-holder.d-inline-flex.bg-light(v-for="(file, file_index) in files", :key="file_index")
            b-img.mr-2(:src="file.src", width="30", height="30", rounded, v-if="file.type === 'image'")
            file-text-icon.mr-2.text-secondary(v-else-if="file.type === 'file'")
            video-icon.mr-2.text-secondary(v-else-if="file.type === 'video'")
            div.d-flex.justify-content-center.align-items-center(v-else-if="file.type === 'audio'").mr-2
              mic-icon.text-secondary
              audio(controls, :src="file.file.src")
            div.d-flex.flex-column
              span.text-secondary {{ file.file ? file.file.name : getFileName(file) }}
              span.text-sm.text-help(v-if="file.file") {{ file.file.size/1024 >= 1024 ? (Math.round(file.file.size/1024/1024) + 'MB') : (Math.round(file.file.size/1024) + 'KB') }}
              b-link.text-sm.text-danger.opacity-70(@click="files.splice(file_index, 1)", href="#") Quitar
        ScrollDownButton.d-flex.justify-content-end.position-absolute(id="button-to-scroll-down", element_id="messages-container", :right="'13'", :bottom="'80'", :nameIcon="'chevron-down'", :colorButton="'soft-primary'", :isScrollUp="false", :container="scrollButton", :message="lastMessage")
        composer-input(
          v-if="conversation.platform !== 'voip'",
          :userId="userData.user_id",
          :user-id="userData.user_id",
          :platform="conversation.platform",
          :files="files",
          :messageToAnswer="messageToAnswer || {}",
          @messageToAnswered="handleMessageTook"
          @files="updateFiles($event)",
          @files:push="pushFiles($event)",
          @files:remove="removeFiles($event)",
          :container="composerInput",
        )
    SideModal(:size="sideModalSize", padding, :value="showSideModal", @input="hideSideModal")
      template
        conversation-box(v-if="side_modal_box")
        conversation-labels(v-if="side_modal_labels")
        conversation-admins(v-if="side_modal_admins")
        conversation-user(v-if="side_modal_user", :conversation="conversation", :tags="tags", :parsed_conversation_messages="parsed_conversation_messages")
        conversation-search(v-if="search_modal")
        conversation-cart(v-if="side_modal_cart", :conversation="conversation", :conversation-id="conversation._id")
        conversation-orders(v-if="side_modal_orders", :conversation="conversation", :conversation-id="conversation._id")
</template>

<script>
import Avatar from './Avatar.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '../helpers/eventBus'
import ScrollDownButton from '@/components/ScrollTopBtn.vue'
import Validators from '@/helpers/data_validators'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
import debounce from 'lodash.debounce'
import { Caller } from '../helpers/caller'

Vue.use(Viewer)

const accountController = createNamespacedHelpers('account')
const ConversationLabels = () => import('./ConversationLabels.vue')
const ConversationAdmins = () => import('./ConversationAdmins.vue')
const ConversationBox = () => import('./ConversationBox.vue')
const ConversationUser = () => import('./ConversationUser.vue')
const TimeLine = () => import('./TimeLine.vue')
const ConversationSearch = () => import('./ConversationSearch')
const ChatTemplates = () => import('./ChatTemplates.vue')
const ConversationCart = () => import('./ConversationCart.vue')
const ConversationOrders = () => import('./ConversationOrders.vue')
const ComposerInput = () => import('./ComposerInput.vue')
const conversationController = createNamespacedHelpers('conversation')
const groupController = createNamespacedHelpers('group')
const tagController = createNamespacedHelpers('tag')
const filtersController = createNamespacedHelpers('inbox_filters')

export default {
  mixins: [Validators.Methods],
  props: {
    border: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      messageToAnswer: '',
      isCallPanelOpen: false,
      canRedirect: false,
      fromNumber: '',
      groupsName: [],
      isToForward: false,
      agentsFields: ['image', 'fullName', 'status'],
      groupsToFilter: [],
      agents: [],
      getAgents: [],
      redirectTo: '',
      componentName: 'Composer',
      callCounter: '',
      totalSeconds: 0,
      intervalId: null,
      device: null,
      openCall: false,
      isMuted: false,
      isCalling: false,
      call: null,
      caller: '',
      token: '',
      adminEmail: '',
      externalId: '',
      scrollButton: null,
      composerInput: null,
      lastMessage: {},
      conversationMessages: [],
      loading: false,
      side_modal_box: false,
      side_modal_labels: false,
      side_modal_admins: false,
      side_modal_user: false,
      search_modal: false,
      first_message_id: undefined,
      conversation: {},
      userData: {},
      viewerOptions: {
        navbar: false,
        toolbar: {
          zoomIn: 4,
          zoomOut: 4,
          oneToOne: 4,
          reset: 4,
          prev: 0,
          play: 0,
          next: 0,
          rotateLeft: 4,
          rotateRight: 4,
          flipHorizontal: 4,
          flipVertical: 4
        }
      },
      files: [],
      forward_page: 1,
      has_forward: false,
      sort: '-1',
      prev_scroll: 0,
      side_modal_cart: false,
      side_modal_orders: false
    }
  },
  computed: {
    ...filtersController.mapGetters(['searchIsEnabled']),
    ...accountController.mapState({
      account: (state) => state.account
    }),
    ...conversationController.mapState({
      conversation_messages: ({ messages = [] }) => {
        const uniqueMessages = new Set(messages.map((message) => message._id))
        return Array.from(uniqueMessages).map((_id) =>
          messages.find((message) => message._id === _id)
        )
      }
    }),
    ...conversationController.mapGetters(['selectedMessage']),
    ...tagController.mapState({
      tags: (state) => state.tags
    }),
    userName() {
      if (Object.keys(this.userData).length) {
        if (this.userData.first_name || this.userData.last_name) {
          return `${this.userData.first_name || ''} ${this.userData.last_name || ''}`
        } else {
          return this.externalId || 'Usuario'
        }
      }

      return ''
    },
    ...groupController.mapState({
      groups: (state) => state.groups
    }),
    ...accountController.mapState({
      admins: (state) => state.admins
    }),
    ...tagController.mapState({
      tags: (state) => state.tags
    }),
    composerStyle() {
      return this.border != undefined
        ? this.border !== false
          ? ''
          : { border: 'none !important' }
        : ''
    },
    showSideModal() {
      return (
        this.side_modal_box ||
        this.side_modal_labels ||
        this.side_modal_admins ||
        this.side_modal_user ||
        this.search_modal ||
        this.side_modal_cart ||
        this.side_modal_orders
      )
    },
    sideModalSize() {
      return this.side_modal_user ||
        this.search_modal ||
        this.side_modal_cart ||
        this.side_modal_orders
        ? 'md'
        : 'sm'
    },
    parsed_conversation_messages() {
      if (!this.conversation_messages.length) return

      let firstMessage = this.conversation_messages[0]

      this.conversationMessages = this.conversation_messages.map((m) => {
        if (!this.$moment(m.date).isSame(firstMessage.date, 'day')) {
          m.new_date = this.$moment(m.date).format('dddd, DD MMMM YYYY')
          firstMessage = m
        }

        return m
      })

      if (this.conversationMessages.length) {
        this.composerInput = document.getElementById('messages-container')
        this.scrollButton = document.getElementById('button-to-scroll-down')

        const indexOfLastMessage = this.conversationMessages.length - 1
        this.lastMessage = this.conversationMessages[indexOfLastMessage]
      }

      return this.conversationMessages
    },
    isEcommerce() {
      return new RegExp('^konverza-ecommerce', 'i').test(this.account.type)
      // todo check ecommerce plugin
      // this.$can('read', 'ecommerce-view')
    }
  },
  methods: {
    ...mapActions([
      'conversation/get',
      'conversation/messages',
      'conversation/getPivotMessages',
      'conversation/update',
      'tag/all',
      'account/admins',
      'group/all',
      'account/getAdminAgents',
      'admin/get'
    ]),
    ...conversationController.mapMutations(['resetSelectedMessage']),
    loadMoreMessages() {
      const self = this
      if (self.pagination_hasNextPage) {
        self.sort = -1
        self.getConversationMessages()
      }

      if (self.has_forward) {
        self.has_forward = false
        self.sort = 1
        self.getConversationMessages()
      }
    },
    handleMessageTook(value) {
      if (typeof value !== 'object') return

      this.messageToAnswer = value
    },
    getConversation() {
      const self = this

      this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          self.conversation = res.resource
          self.userData = res.resource.user || {}
          self.externalId = res.resource.user.external_id

          self.getConversationMessages()
          self.updateConversation({ read: true })
        }
      })
    },
    openUserInfo() {
      this.side_modal_user = true
    },
    updateConversation(data) {
      const self = this

      this['conversation/update']({
        conversation_id: self.$route.params.conversation_id,
        ...data
      })
    },
    getConversationMessages() {
      this.loading = true
      let params = {
        ...this.paginationParams,
        sort: this.sort,
        isSearch: this.searchIsEnabled
      }

      if (this.sort === 1) {
        params = {
          page: this.forward_page,
          limit: 24,
          sort: this.sort
        }
      }

      if (this.selectedMessage) {
        const { selectedMessage } = this
        params.pivot_id = selectedMessage._id || selectedMessage
        this.resetSelectedMessage()
      }

      this['conversation/messages']({
        conversation_id: this.$route.params.conversation_id,
        params,
        callback: (res) => {
          this.hideLoadingScreen()
          if (res.error) {
            return this.$message.error(res.error)
          }
          let { sort } = this
          sort = Number(sort)
          if (sort === -1) {
            this.parseResponseForPaginationData(res)
          } else {
            this.forward_page++
            this.has_forward = !!res.resource.length
          }
          this.$nextTick(() => {
            if (params.pivot_id) this.goToMessage(params.pivot_id)
            const { _id: firstMessageId } = this.conversation_messages[0] || {}
            if (this.first_message_id && sort === -1) {
              const container = $('#messages-container')
              const message = $(
                `#messages-container [_id=${this.first_message_id}]`
              ).first()
              if (message) {
                try {
                  container.scrollTop(
                    message.offset().top - container.offset().top
                  )
                } catch (e) {
                  console.log(e)
                }
              }
            }

            this.first_message_id = firstMessageId
          })
        }
      })
    },
    getFileName(file) {
      const field = file.url || file.src

      if (!field) return 'Nombre de archivo no disponible'

      try {
        return decodeURIComponent(
          field
            .match(/\.com\/.+\.\w{3,4}/gim)[0]
            .split('/')
            .slice(-1)[0]
        )
      } catch (e) {
        console.log(e.message)
        return 'Nombre de archivo no disponible'
      }
    },
    hideSideModal() {
      this.side_modal_box = false
      this.side_modal_labels = false
      this.side_modal_admins = false
      this.side_modal_user = false
      this.search_modal = false
      this.side_modal_cart = false
      this.side_modal_orders = false
      if (this.selectedMessage) {
        this.$nextTick(() => {
          this.scrollIntoView()
        })
      }
    },
    clearMessages() {
      this.$store.commit('conversation/setMessages', [])
    },
    getAdmins() {
      return new Promise((resolve) => {
        const self = this

        if (this.admins.length) resolve(true)

        this['account/admins']({
          account_id: self.$route.params.account_id,
          callback: (res) => {
            if (res.error) {
              self.$message.error(res.error)
            }

            resolve(true)
          }
        })
      })
    },
    getGroups() {
      return new Promise((resolve) => {
        const self = this

        if (this.groups.length) resolve(true)

        this['group/all']({
          account_id: self.$route.params.account_id,
          callback: (res) => {
            if (res.error) {
              self.$message.error(res.error)
            }

            resolve(true)
          }
        })
      })
    },
    updateFiles(files) {
      this.files = files
    },
    pushFiles(files) {
      this.files.push(files)
    },
    removeFiles(index) {
      this.files.splice(index, 1)
    },
    getPivotMessages() {
      const self = this
      // this.showLoadingScreen()

      this['conversation/getPivotMessages']({
        message_id: self.selectedMessage._id,
        params: {
          ...self.paginationParams
        },
        callback: (res) => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parseResponseForPaginationData(res)
            self.forward_page++
          }
        }
      })
    },
    goToMessage: debounce((message) => {
      const container = document.getElementById('messages-container')
      const messageElement = $(`#messages-container [_id=${message}]`).first()

      if (
        !messageElement &&
        !messageElement.offset() &&
        !messageElement.offset().top
      ) return
      if (container && messageElement.offset().top) {
        container.scrollTo({
          top: messageElement.offset().top,
          behavior: 'smooth'
        })
      }
    }, 2000),
    goToExactMessage(message) {
      //this.$store.commit('inbox_filters/enableSearch', true)
      //this.$store.commit('conversation/selectMessage', message) --> Review logic

      const params = {
        isSearch: this.searchIsEnabled,
        pivot_id: message._id || message
      }

      this['conversation/messages']({
        conversation_id: this.$route.params.conversation_id,
        params,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.$nextTick(() => {
            const index = this.conversation_messages.findIndex(({ _id }) => {
              return _id === message._id
            })

            if (index >= 0) {
              const { _id: firstMessageId } = this.conversation_messages[index] || {}

              if (firstMessageId) {
                const container = $('#messages-container')
                const messageFound = $(
                  `#messages-container [_id=${firstMessageId}]`
                ).first()

                if (messageFound) {
                  try {
                    if (messageFound.offset().top >= 500) {
                      container.scrollTop(messageFound.offset().top - container.offset().top)
                    } else if (messageFound.offset().top <= 0) {
                      container.scrollTop(messageFound.offset().top - container.offset().top)
                    }
                  } catch (e) {

                  }
                }
              }

              this.first_message_id = firstMessageId
            }
          })
        }
      })
    },
    scrollIntoView() {
      const searchMsg = this.conversation_messages.find(
        (m) => m._id == this.selectedMessage._id
      )

      if (searchMsg) {
        const container = $('#messages-container')
        const message = $(`#messages-container [_id=${searchMsg._id}]`).first()

        if (message) {
          container.scrollTop(
            Math.abs(container.offset().top - message.offset().top)
          )

          this.has_forward = true
        }

        this.first_message_id = this.conversation_messages[0]
          ? this.conversation_messages[0]._id
          : null
      }
    },
    clearSearch() {
      this.$store.commit('conversation/selectMessage', null)
      this.$store.commit('conversation/setSearchMessages', [])
    }
  },
  mounted() {
    this.getConversation()

    EventBus.$on('search:getConversation', () => {
      this.clearMessages()
      this.$nextTick(() => {
        this.getConversation()
      })
    })
    const promises = [this.getAdmins(), this.getGroups()]
    Promise.all(promises).then(() => {})

    EventBus.$on('conversation/updated', (event) => {
      if (event) {
        this.conversation = event

        return this.conversation
      }
    })

    EventBus.$on('conversationId', ({ _id, bot_enabled: botEnabled }) => {
      this.$store.commit('conversation/updateConversationData', {
        _id,
        key: 'bot_enabled',
        value: botEnabled
      })
    })

    try {
      document.title = this.dashboardTitle
    } catch (e) {}
  },
  async beforeUnmount() {
    EventBus.$off('conversation/updated')
    EventBus.$off('search:getConversation')
    this.clearMessages()
    this.clearSearch()

    EventBus.$emit('hangUpCallWhenReset')
  },
  async unmounted() {
    EventBus.$off('conversationId')

    EventBus.$emit('hangUpCallWhenReset')
  },
  watch: {
    device() {
      this.$emit('putDevice', this.device)
    },
    isCallPanelOpen() {
      EventBus.$emit('putIsCallPanelOpen', this.isCallPanelOpen)
    },
    $route(value) {
      this.first_message_id = undefined
      this.conversation = {}
      this.page_past = 1
      this.has_past = false
      this.sort = '-1'
      this.$store.commit('conversation/setSearchMessages', [])
      this.$store.commit('conversation/selectMessage', null)
      this.clearMessages()
      this.resetPagination()
      this.getConversation()
    },
    conversation(value) {
      document.title = `Chat - ${this.userName}`
    },
    selectedMessage(val) {
      if (!val) return

      this.first_message_id = undefined
      this.forward_page = 1
      this.has_forward = false
      this.sort = -1
      this.clearMessages()
      this.resetPagination()
      if (this.searchIsEnabled) return
      val ? this.getPivotMessages() : this.getConversationMessages()
    }
  },
  components: {
    Avatar,
    ConversationLabels,
    ConversationAdmins,
    ConversationBox,
    ConversationUser,
    ConversationSearch,
    ChatTemplates,
    ComposerInput,
    ConversationCart,
    ConversationOrders,
    ScrollDownButton,
    TimeLine
  }
}
</script>

<style lang="scss" scoped>
audio::-webkit-media-controls-panel {
  background-color: #edf2f9;
}

audio::-webkit-media-controls-current-time-display {
  font-size: 15px;
}

audio::-webkit-media-controls-time-remaining-display {
  font-size: 15px;
}

audio::-webkit-media-controls-play-button {
  background-color: rgba(183, 206, 255, 1);
  border-radius: 50px;
  padding: 15px;
}

audio::-webkit-media-controls-play-button:hover {
  background-color: #ccdcff;
}
.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}

.attachments-area {
  width: 100%;
  height: 70px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
}

#button-to-scroll-down {
  z-index: 1;
  padding: 11.5px;
}

.attachment-holder {
  padding: 10px;
  border-radius: 5px;
  margin: 5px;

  img {
    object-fit: cover !important;
  }
}

.date-tag {
  padding: 5px 15px;
  border-radius: 15px;
}

.margin {
  margin: 0px auto;
}

.text {
  font-size: 12px;
  font-weight: lighter;
}
.call {
  position: absolute;
  z-index: 999;
  width: 98% !important;
  left: 6px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}
.zIndex {
  z-index: 999;
  position: absolute;
  top: 80px;
}
.pulser {
  animation: pulse 0.4s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>
